export default {
  loadFailed: '性能设置读取失败',
  rfStrategy: {
    title: '无线射频策略',
    smart: '智能调节',
    fullPower: '满格射频',
    smartDesc: '根据信号强度智能调节射频功率，更加节能',
    fullPowerDesc: '保持满格射频，功率更大，抗干扰更强',
  },
  battery: {
    title: '续航计算器',
    tooltip: '续航时间为该性能模式满电情况下连续使用的参考数值，根据个人使用环境等不同而存在差异！',
    currentConfig: '当前配置下',
    fullCharge: '满电续航可达',
  },
  rfPacket: {
    title: '通讯协议设置',
    turbo: '高效协议turbo',
    initial: '初始协议',
  },
  keyScanRate: '按键扫描率',
  reportRate: '回报率',
  reportRate16k: {
    usb2: {
      title: '提示',
      content:
        '检测到USB2.0端口或非原装USB3.0数据线。16K报告速率不可用。需启动16k请使用原装USB3.0数据线的端口以获得最佳性能。',
    },
    usb3: {
      title: '提示',
      content:
        '检测到您的设备已连接至USB3.0及以上接口。若要开启16k回报率，请下载安装专用的支持文件，并使用原装或高品质USB3.0数据线。安装后请重新插拔设备。',
      confirm: '下载',
    },
  },
  usbSpeed: {
    usb3: 'USB 3.0',
    usb2: 'USB 2.0',
    driverInstalled: '已安装',
    driverNotInstalled: '未安装',
    getInfoDetail: '{usbLabel}（GetInfo[6]=0x{statusHex}，16K驱动{driverState}，数据区 {rawHex}）',
    webUsbBcd: 'WebUSB bcdUSB {major}.{minor}',
    statusUsb3With16k: 'USB 3.0（16K 回报率可用）',
    statusUsb3NoDriver: 'USB 3.0（未安装 16K 驱动）',
    statusNotUsb3: '非 USB 3.0（16K 回报率不可用）',
    statusUnknown: '无法判定',
    detecting: '检测中...',
    driverLabelInstalled: '已安装',
    driverLabelNotInstalled: '未安装',
    autoUsb3WithDriver: 'USB 3.0（16K 驱动{state}）',
    autoUsb2Unavailable: 'USB 2.0（16K 不可用）',
    webUsbVerifyOk: '✓ WebUSB 校验：USB 3.0（{detail}）',
    webUsbVerifyFail: '✗ WebUSB 校验：非 USB 3.0（{detail}）',
    webUsbVerifyUnknown: 'WebUSB 校验：无法判定（未授权/未找到设备）',
    webUsbVerifyButton: 'WebUSB 校验',
    verifying: '校验中...',
    testPanel: {
      title: 'USB 3.0 连接检测',
      guide:
        '该键盘 16K 回报率需要 USB 3.0 连接才能实现。点击按钮检测当前连接是否为 USB 3.0—— 读取 GetInfo(0x03) 数据区偏移 6 判断（bit0=16K 驱动，bit1=USB 2.0/3.0），纯 WebHID 只读、无需操作键盘、不写键盘、不额外授权。',
      startButton: '检测 USB 3.0',
      sourceLabel: '判定来源',
      sourceValue: 'GetInfo 只读字段（WebHID）',
      driverFieldLabel: '16K 驱动',
      rawFieldLabel: '数据区原始字节',
      detailUsb3Ready: '检测到当前连接为 USB 3.0 且已安装 16K 驱动，16K 回报率可用。',
      detailUsb3NoDriver: '检测到当前连接为 USB 3.0，但未安装 16K 驱动。',
      detailNotUsb3: '检测到当前连接不是 USB 3.0，16K 回报率不可用；请改用 USB 3.0 接口或线材。',
      detailUnknown: '无法判定（GetInfo 响应异常），请确认键盘已连接后重试。',
    },
  },
  sensorMode: {
    frenzy: {
      title: '狂暴竞技模式',
      excerpt1: '≥20K引擎速率',
      excerpt2: '疾速扫描至强性能',
    },
    competitive: {
      title: '竞技超核模式',
      excerpt1: '≥{scanRate}FPS引擎扫描帧速率',
      excerpt2: '全速竞技，性能全开',
    },
    hyperCore: {
      title: '超核模式',
      excerpt1: '超核电竞，微秒响应',
    },
    firepower: {
      title: '火力模式',
      excerpt1: '电竞游戏，轻松拿捏',
    },
    balanced: {
      title: '均衡模式',
      excerpt1: '游戏娱乐，开心无虑',
    },
    office: {
      title: '办公模式',
      excerpt1: '日常游戏，兼顾办公',
    },
  },
  keyboard: {
    reportRate: {
      title: '键盘回报率 (Hz)',
      description: '较高的键盘回报率，可减少输入延迟带来的影响。',
    },
    debounce: {
      title: '防抖等级',
      description: '数值越高，按键触发前的防抖过滤越强。',
      low: '低',
      high: '高',
    },
    tickRate: {
      title: 'Tick 速率',
      description: '更高的速率可降低出错概率，但可能占用更多系统资源。',
      none: '无 Tick 速率',
      tick30: '30 Tick 速率',
      tick60: '60 Tick 速率',
    },
    toggles: {
      winLock: {
        title: 'Win 键锁定',
        description: '开启后，Win 键将被锁定无法使用，防止游戏中误触。',
      },
      fullAntiGhosting: {
        title: '全键无冲',
        description: '开启后，将由 6 键无冲切换为全键无冲，适配特殊场景',
      },
      adaptiveCalibration: {
        title: '自适应动态校准 2.0',
        description: '使用过程中自动校准按键行程，保持稳定触发。',
      },
      bottomOutStabilization: {
        title: '触底稳定',
        description: '减少触底时的误触发，建议在需要稳定输入时开启。',
      },
      macMode: {
        title: 'MAC 模式',
        description: '切换为适配 macOS 的键盘布局。',
      },
      swapWASD: {
        title: '交换 WASD',
        description: '将方向键与 WASD 键互换。',
      },
      lockAltTab: {
        title: '锁定 ALT+TAB',
        description: '开启后可防止误触窗口切换。',
      },
      lockAltF4: {
        title: '锁定 ALT+F4',
        description: '开启后可防止误触关闭程序。',
      },
    },
  },
}
